import type * as t from "./types";

/**
 * Request params helper function
 * @param initialParams
 * @param countryCode
 * @param hasSingleCountry
 */
export const buildSignalsRequestParamsForAllOrInverse = (
    initialParams: t.SignalsRequestParams,
    countryCode: number,
    hasSingleCountry: boolean,
): t.SignalsRequestParams => {
    if (hasSingleCountry) {
        return {
            ...initialParams,
            countryCode,
            inverse: true,
        };
    }

    return initialParams;
};
